import { render, staticRenderFns } from "./AlterarApoiado.vue?vue&type=template&id=2cd44ee8&"
import script from "./AlterarApoiado.vue?vue&type=script&lang=js&"
export * from "./AlterarApoiado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports